import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export function ReportsPage() {
  return (
    <div className="space-y-6">
      <div>
        <div className="flex items-center gap-2">
          <h1 className="text-3xl font-bold tracking-tight">Reports</h1>
          <Badge variant="outline" className="bg-yellow-50 text-yellow-700 border-yellow-200">
            🟡 Demo Mode
          </Badge>
        </div>
        <p className="text-muted-foreground mt-2">
          Generate comprehensive reports on stock levels, movements, valuations, and performance metrics.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Content Coming Soon</CardTitle>
          <CardDescription>
            This page will provide a library of customizable reports with export capabilities.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-sm text-muted-foreground">
            <p className="mb-2">Planned features:</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Stock valuation reports</li>
              <li>Movement history reports</li>
              <li>Aging analysis</li>
              <li>Custom report builder</li>
              <li>Scheduled report generation</li>
            </ul>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
